/**
 * @generated SignedSource<<996f852d51aaf13d46c8097917d26f3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PriceOverrideInput = {
  daily?: number | null | undefined;
  hourly?: number | null | undefined;
  monthly?: number | null | undefined;
  monthlyCap?: number | null | undefined;
  outboundNetworkTransferPerGigabyte?: number | null | undefined;
  percentagePerProject?: number | null | undefined;
  pricePerUnit?: number | null | undefined;
  sku: string;
};
export type AnalysisSimulationViewQuery$variables = {
  overrides: ReadonlyArray<PriceOverrideInput>;
  periodEnd: any;
  periodStart: any;
};
export type AnalysisSimulationViewQuery$data = {
  readonly simulateSubscriptionRevenue: {
    readonly baseline: {
      readonly total: number;
    };
    readonly delta: number;
    readonly deltaPercent: number | null | undefined;
    readonly simulated: {
      readonly byCostCategory: ReadonlyArray<{
        readonly amount: number;
        readonly key: string;
        readonly label: string;
        readonly previousAmount: number;
      }>;
      readonly byCustomerAccount: ReadonlyArray<{
        readonly amount: number;
        readonly key: string;
        readonly label: string;
        readonly previousAmount: number;
      }>;
      readonly settlementCount: number;
      readonly total: number;
    };
    readonly usedSkus: ReadonlyArray<string>;
  };
};
export type AnalysisSimulationViewQuery = {
  response: AnalysisSimulationViewQuery$data;
  variables: AnalysisSimulationViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "overrides"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "periodEnd"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "periodStart"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "previousAmount",
    "storageKey": null
  }
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "overrides",
        "variableName": "overrides"
      },
      {
        "kind": "Variable",
        "name": "periodEnd",
        "variableName": "periodEnd"
      },
      {
        "kind": "Variable",
        "name": "periodStart",
        "variableName": "periodStart"
      }
    ],
    "concreteType": "SimulatedRevenueReport",
    "kind": "LinkedField",
    "name": "simulateSubscriptionRevenue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RevenueAggregate",
        "kind": "LinkedField",
        "name": "baseline",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RevenueAggregate",
        "kind": "LinkedField",
        "name": "simulated",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "settlementCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RevenueBreakdownEntry",
            "kind": "LinkedField",
            "name": "byCustomerAccount",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RevenueBreakdownEntry",
            "kind": "LinkedField",
            "name": "byCostCategory",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "delta",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deltaPercent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usedSkus",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisSimulationViewQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AnalysisSimulationViewQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "9912ae46f44723ca472b930e5d9a60e0",
    "id": null,
    "metadata": {},
    "name": "AnalysisSimulationViewQuery",
    "operationKind": "query",
    "text": "query AnalysisSimulationViewQuery(\n  $periodStart: DateTime!\n  $periodEnd: DateTime!\n  $overrides: [PriceOverrideInput!]!\n) {\n  simulateSubscriptionRevenue(periodStart: $periodStart, periodEnd: $periodEnd, overrides: $overrides) {\n    baseline {\n      total\n    }\n    simulated {\n      total\n      settlementCount\n      byCustomerAccount {\n        key\n        label\n        amount\n        previousAmount\n      }\n      byCostCategory {\n        key\n        label\n        amount\n        previousAmount\n      }\n    }\n    delta\n    deltaPercent\n    usedSkus\n  }\n}\n"
  }
};
})();

(node as any).hash = "47a0df1b41a0d2b050faf853b32332a0";

export default node;
